module.exports = __webpack_public_path__ + "static/blue_layer-f2d0b06b753abde1b48ef96dc937cf48.png";